module.exports = __webpack_public_path__ + "img/pagos.42cc2bf1.svg";